import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconBuildingBank,
  IconArrowsTransferUp,
  IconCash,
  IconWallet,
} from '@tabler/icons-react'

export const cachierModuleKey = 'cachier'
export const balanceTransferModuleKey = 'balance_transfer'

const cachierRoute: RouteConfig = {
  uid: cachierModuleKey,
  path: 'billing/cachier',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/billing/cachier')).default,
  }),
}

const cachierDetailRoute: RouteConfig = {
  uid: cachierModuleKey,
  path: 'billing/cachier/:id',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/billing/cachier-detail')).default,
  }),
}

const documentDetailRoute: RouteConfig = {
  uid: cachierModuleKey,
  path: 'billing/cachier/:id/documents/:documentId',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/billing/document-detail')).default,
  }),
}

const cachierTransferRoute: RouteConfig = {
  uid: cachierModuleKey,
  path: 'billing/cachier-transfer',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/billing/cachier-transfer')).default,
  }),
}

const transferDetailRoute: RouteConfig = {
  uid: cachierModuleKey,
  path: 'billing/cachier-transfer/:transferId',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/billing/transfer-detail')).default,
  }),
}

const balanceRoute: RouteConfig = {
  uid: balanceTransferModuleKey,
  path: 'billing/balance',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/billing/balance')).default,
  }),
}

const balanceTransferDetailRoute: RouteConfig = {
  uid: balanceTransferModuleKey,
  path: 'billing/balance-transfer/:id',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/billing/balance-transfer-detail'))
      .default,
  }),
}

export const sidelink: SideLink = {
  title: 'billing',
  href: 'billing',
  icon: <IconBuildingBank size={18} />,
  order: 3.2,
  sub: [
    {
      uid: cachierModuleKey,
      title: 'kassa',
      href: 'billing/cachier',
      icon: <IconCash size={18} />,
      order: 1,
    },
    {
      uid: cachierModuleKey,
      title: 'kassa_transfer',
      href: 'billing/cachier-transfer',
      icon: <IconArrowsTransferUp size={18} />,
      order: 2,
    },
    {
      uid: balanceTransferModuleKey,
      title: 'balance_transfer',
      href: 'billing/balance',
      icon: <IconWallet size={18} />,
      order: 3,
    },
  ],
}

export default [
  cachierRoute,
  cachierDetailRoute,
  documentDetailRoute,
  cachierTransferRoute,
  transferDetailRoute,
  balanceRoute,
  balanceTransferDetailRoute,
]
